import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Button } from "@atoms";
import { history } from "@src/history";
import { accountUrl } from "@src/app/routes";
import { getDBIdFromGraphqlId } from "@utils";
import { DeviceContext, deviceType } from "@providers";

const PendingReviewItem: React.FC<IProps> = (
  {
    product
  }: IProps) => {
  const productDbId = getDBIdFromGraphqlId(product.id, "Product");
  const handleClick = (e: any) => {
    history.push(`${accountUrl}write-reviews/${productDbId}/`);
  }
  const isMobile = React.useContext<deviceType>(DeviceContext).isMobile;
  
  return (
    <S.Wrapper ismobile={isMobile.toString()}>
      <S.PendingReviewCol xs={4} md={2}>
        <img src={product.images[0].url} width="80px"/>
      </S.PendingReviewCol>
      <S.PendingReviewCol xs={4} md={7}>
        <S.PendingReviewBrand>{product.brand}</S.PendingReviewBrand>
        <S.PendingReviewProductName>{product.name}</S.PendingReviewProductName>
      </S.PendingReviewCol>
      <S.PendingReviewCol xs={4} md={3}>
        <Button fullWidth onClick={handleClick}>
          Write
        </Button>
      </S.PendingReviewCol>
    </S.Wrapper>
  )
};

export { PendingReviewItem }